import { captureLead } from '$lib/global/consent/leadCapture';

import { getTrackingService } from './TrackingServiceInstance';

export const updateVisitorProperties = (
    obj: { [key: string]: unknown },
    options?: { suppressConversion?: boolean },
) => getTrackingService().getSession().updateVisitorProperties(obj, options);

/**
 * Applied after a form submit whose conversion was held back until phone/email verification
 * succeeded (FUN-3876), so this is a form-submit boundary too — hence the CAP-4169 lead
 * delivery, which is what stamps the rejected visitor's lead as converted.
 */
export const triggerDeferredConversion = () => {
    getTrackingService().getSession().triggerDeferredConversion();
    captureLead();
};

export const getVisitorProperties = () => getTrackingService().getSession().getVisitorProperties();
